module.exports = __webpack_public_path__ + "img/rongyu.2a9c343e.png";